var _defaultAttrs;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import merge from 'deepmerge';
import namespaces from 'svg-baker/namespaces';
import objectToAttrsString from './object-to-attrs-string';
var svg = namespaces.svg,
    xlink = namespaces.xlink;
var defaultAttrs = (_defaultAttrs = {}, _defineProperty(_defaultAttrs, svg.name, svg.uri), _defineProperty(_defaultAttrs, xlink.name, xlink.uri), _defaultAttrs);
/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */

export default function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var attributes = arguments.length > 1 ? arguments[1] : undefined;
  var attrs = merge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return "<svg ".concat(attrsRendered, ">").concat(content, "</svg>");
}